import React, { useCallback } from "react";
import { createContext, useState } from "react";
export const popupcontext = createContext();
export default function PopupContext({ children }) {
	//Form
	const [form, setForm] = useState(false);
	const [isDeleting, setIsDeleting] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [edited, setEdited] = useState(false);
	const [deleted, setDeleted] = useState(false);
	const [deleteItem, setDeleteItem] = useState({
		condition: null,
		value: null,
	});
	const [show, setShow] = useState({ type: null, value: false });

	const [display, setDisplay] = useState(false);
	const [remove, setRemove] = useState(false);
	const [object, setObject] = useState(false);
	const [objectbody, setObjectbody] = useState(true);
	const [objectselect, setObjectselect] = useState(false);
	const [objectdraggable, setObjectDraggable] = useState(false);
	const [objectdraggablemini, setObjectDraggableMini] = useState({
		status: false,
	});
	const [displayGeo, setDisplayGeo] = useState(false);
	const [displayNotification, setDisplayNotification] = useState(false);
	const [displayAlert, setDisplayAlert] = useState(false);
	const [currentVehicleId, setCurrentVehicleId] = useState(null);
	const [currentDriverId, setCurrentDriverId] = useState(null);
	const [currentUserId, setCurrentUserId] = useState(null);
	const [currentSubUserId, setSubCurrentUserId] = useState(null);
	const [currentGeofenceId, setCurrentGeofenceId] = useState(null);
	const [currentNotificationId, setCurrentNotificationId] = useState(null);
	const [currentGroupId, setCurrentGroupId] = useState(null);
	const [currentTechnicianId, setCurrentTechnicianId] = useState(null);
	const [currentMaintenanceId, setCurrentMaintenanceId] = useState(null);
	const [currentFormId, setCurrentFormId] = useState(null);
	const [currentTaskId, setCurrentTaskId] = useState(null);
	const [currentPOIId, setcurrentPOIId] = useState(null);
	const [currentRequestId, setcurrentRequestId] = useState(null);
	const [currentPermissionId, setcurrentPermissionId] = useState(null);
	const [currentRoleId, setcurrentRoleId] = useState(null);
	const [currentCustomerId, setcurrentCustomerId] = useState(null);
	const [currentIRId, setcurrentIRId] = useState(null);
	const [currentSnagId, setcurrentSnagId] = useState(null);
	const [currentSubmittalId, setcurrentSubmittalId] = useState(null);
	const [currentCompanyId, setCurrentCompanyId] = useState(null);
	const [currentTeamId, setCurrentTeamId] = useState(null);
	const [currentMemberId, setCurrentMemberId] = useState(null);

	const [refetchGeofences, setRefetchGeofences] = useState(false);

	const [attachments, setAttachments] = useState([]);
	const [attachmentsId, setAttachmentsId] = useState([]);
	const [picture, setPicture] = useState(false);
	const [historyPlayback, setHistoryPlayback] = useState({
		state: false,
		Id: 0,
	});
	const [isPlaying, setIsPlaying] = useState(false);
	const [posIndex, setPosIndex] = useState(0);
	const [userPopup, setuserPopup] = useState(true);
	const [isFullScreen, setIsFullScreen] = useState(false);
	const [options, setOptions] = useState(false);
	const [refetchTrigger, setRefetchTrigger] = useState(0);
	const [isControlsPopup, setIsControlsPopup] = useState(false);
	const [isLinking, setIsLinking] = useState(false);
	const [activeConnection, setActiveConnection] = useState(null);
	const [openShiftPopup, setOpenShiftPopup] = useState(false);
	const [reloadData, setReloadData] = useState(false);
	const [resubmission, setResubmission] = useState(false);
	const [isAssigning, setIsAssigning] = useState(false);
	const [activeRole, setActiveRole] = useState(null);
	const [isAssigningProjects, setIsAssigningProjects] = useState(false);
	const [activeCompany, setActiveCompany] = useState(null);
	const [isAssigningTeam, setIsAssigningTeam] = useState(false);
	const [activeUserForTeam, setActiveUserForTeam] = useState(null);
	const [isAssigningMemberToTeams, setIsAssigningMemberToTeams] =
		useState(false);
	const [activeMemberForTeams, setActiveMemberForTeams] = useState(null);
	const [isAssigningMembersToTeam, setIsAssigningMembersToTeam] =
		useState(false);
	const [activeTeamForMembers, setActiveTeamForMembers] = useState(null);
	const [isAssigningCompany, setIsAssigningCompany] = useState(false);
	const [activeUserForCompany, setActiveUserForCompany] = useState(null);
	const [konvaMode, setKonvamode] = useState(true);
	const [konvaCoord, setKonvaCoord] = useState(null);
	const [continueSetup, setContinueSetup] = useState(false);
	const [currentCompanyProjectId, setcurrentCompanyProjectId] = useState(null);
	const [currentConfigurationId, setConfigurationId] = useState(null);
	const [offlineMode, setOfflineMode] = useState(false);
	const [highlight, setHighlight] = useState(false);
	const [offlinePopup, setOfflinePopup] = useState(false);

	const [currentBeatPlanId, setCurrentBeatPlanId] = useState(null);
	const [currentPlannerId, setCurrentPlannerId] = useState(null);

	const handleClose = (type) => {
		if (type === "form") {
			setForm(false);
			setTimeout(() => {
				setIsEditing(false);
			}, 300);
			setCurrentDriverId(null);
			setCurrentVehicleId(null);
			setCurrentNotificationId(null);
			setCurrentUserId(null);
			setCurrentTechnicianId(null);
			setCurrentMaintenanceId(null);
			setCurrentTaskId(null);
			setcurrentPOIId(null);
			setcurrentRequestId(null);
			setcurrentPermissionId(null);
			setcurrentRoleId(null);
			setcurrentCustomerId(null);
			setcurrentSnagId(null);
			setcurrentIRId(null);
			setcurrentSubmittalId(null);
			setCurrentTeamId(null);
			setCurrentMemberId(null);
			setCurrentBeatPlanId(null);
			setCurrentPlannerId(null);
		}
		if (type === "display") {
			setCurrentVehicleId(null);
			setCurrentDriverId(null);
			setCurrentUserId(null);
			setCurrentGeofenceId(null);
			setuserPopup(false);
			setCurrentTechnicianId(null);
			setCurrentMaintenanceId(null);
			setCurrentFormId(false);
			setCurrentTaskId(null);
			setcurrentPOIId(null);
			setCurrentCompanyId(null);
			setcurrentRequestId(null);
			setcurrentPermissionId(null);
			setcurrentRoleId(null);
			setcurrentCustomerId(null);
			setcurrentSnagId(null);
			setcurrentIRId(null);
			setcurrentSubmittalId(null);
			setCurrentTeamId(null);
			setCurrentMemberId(null);
			setCurrentBeatPlanId(null);
		}
		if (type === "deleting") {
			setIsDeleting(false);
			setRemove(false);
			setCurrentDriverId(null);
			setCurrentVehicleId(null);
			setCurrentUserId(null);
			setSubCurrentUserId(null);
			setCurrentGeofenceId(null);
			setDisplayGeo(false);
			setCurrentNotificationId(null);
			setCurrentGroupId(null);
			setCurrentTechnicianId(null);
			setCurrentMaintenanceId(null);
			setCurrentFormId(null);
			setCurrentTaskId(null);
			setcurrentPOIId(null);
			setcurrentRequestId(null);
			setcurrentPermissionId(null);
			setcurrentRoleId(null);
			setcurrentCustomerId(null);
			setcurrentSnagId(null);
			setcurrentIRId(null);
			setCurrentCompanyId(null);
			setCurrentTeamId(null);
			setCurrentMemberId(null);
			setcurrentCompanyProjectId(null);
			setConfigurationId(null);
			setCurrentBeatPlanId(null);
		}
		if (type === "editing") {
			setCurrentDriverId(null);
			setCurrentVehicleId(null);
			setCurrentUserId(null);
			setCurrentGeofenceId(null);
			setCurrentNotificationId(null);
			setCurrentGroupId(null);
			setIsEditing(false);
			setDisplayGeo(false);
			setCurrentTechnicianId(null);
			setCurrentMaintenanceId(null);
			setCurrentTaskId(null);
			setcurrentPOIId(null);
			setcurrentRequestId(null);
			setcurrentPermissionId(null);
			setcurrentRoleId(null);
			setcurrentCustomerId(null);
			setcurrentSubmittalId(null);
			setCurrentCompanyId(null);
			setCurrentTeamId(null);
			setCurrentBeatPlanId(null);
		}
		if (type === "object") {
			setObjectbody(false);
		}
		if (type === "objectSelected") {
			setObject(false);
			setObjectselect(false);
			setHistoryPlayback(false);
		}
		if (type === "minimizeSelected") {
			setObjectselect(false);
		}
		if (
			type === "objectUsers" ||
			type === "historyPlayBack" ||
			type === "workorders"
		) {
			setDisplay(false);
		}
		if (type === "notification") {
			setDisplayNotification(false);
		}
	};
	const handleShow = (name, type, id) => {
		if (name === "addForm") setForm(true);
		if (name === "editForm") handleEditForm(type, id);
		if (name === "deleteItem") {
			handleRemove(type, id);
		}
		if (name === "assignProjects") {
			setIsAssigningProjects(true);
			setActiveCompany({ id, type });
		}
		if (name === "assignTeam") {
			setIsAssigningTeam(true);
			setActiveUserForTeam({ id });
		}
		if (name === "assignCompany") {
			setIsAssigningCompany(true);
			setActiveUserForCompany({ id });
		}
		if (
			name === "objectUsers" ||
			name === "historyPlayBack" ||
			name === "workorders" ||
			name === "pois"
		)
			setDisplay(true);
		if (name === "notification") setDisplayNotification(true);
	};

	const handleEditForm = (name, id) => {
		if (name === "vehicles") {
			setCurrentVehicleId(id);
			setIsEditing(true);
			setForm(true);
		}
		if (name === "drivers") {
			setIsEditing(true);
			setForm(true);
			setCurrentDriverId(id);
		}
		if (name === "users") {
			setIsEditing(true);
			setForm(true);
			setCurrentUserId(id);
		}
		if (name === "geofences") {
			setIsEditing(true);
			setDisplayGeo(true);
			setCurrentGeofenceId(id);
		}
		if (name === "notifications") {
			setIsEditing(true);
			setForm(true);
			setCurrentNotificationId(id);
		}
		if (name === "groups") {
			setIsEditing(true);
			setForm(true);
			setCurrentGroupId(id);
		}
		if (name === "technician") {
			setIsEditing(true);
			setForm(true);
			setCurrentTechnicianId(id);
		}
		if (name === "maintenance") {
			setIsEditing(true);
			setForm(true);
			setCurrentMaintenanceId(id);
		}
		if (name === "task") {
			setIsEditing(true);
			setForm(true);
			setCurrentTaskId(id);
		}
		if (name === "pois") {
			setIsEditing(true);
			setForm(true);
			setcurrentPOIId(id);
		}
		if (name === "request") {
			setIsEditing(true);
			setForm(true);
			setcurrentRequestId(id);
		}
		if (name === "permission") {
			setIsEditing(true);
			setForm(true);
			setcurrentPermissionId(id);
		}
		if (name === "role") {
			setIsEditing(true);
			setForm(true);
			setcurrentRoleId(id);
		}
		if (name === "customer") {
			setIsEditing(true);
			setForm(true);
			setcurrentCustomerId(id);
		}
		if (name === "IR") {
			setIsEditing(true);
			setForm(true);
			setcurrentIRId(id);
		}
		if (name === "submittal") {
			setIsEditing(true);
			setForm(true);
			setcurrentSubmittalId(id);
		}
		if (name === "company") {
			setIsEditing(true);
			setForm(true);
			setCurrentCompanyId(id);
		}
		if (name === "team") {
			setIsEditing(true);
			setForm(true);
			setCurrentTeamId(id);
		}
		if (name === "member") {
			setIsEditing(true);
			setForm(true);
			setCurrentMemberId(id);
		}
		if (name === "beatPlan") {
			setIsEditing(true);
			setForm(true);
			setCurrentBeatPlanId(id);
		}
		if (name === "recurringPlanner") {
			setIsEditing(true);
			setForm(true);
			setCurrentPlannerId(id);
		}
	};

	const handleRemove = (name, id) => {
		setIsDeleting(true);
		if (name === "vehicles") setCurrentVehicleId(id);
		if (name === "drivers") setCurrentDriverId(id);
		if (name === "users") setCurrentUserId(id);
		if (name === "subusers") setSubCurrentUserId(id);
		if (name === "geofences") setCurrentGeofenceId(id);
		if (name === "notifications") setCurrentNotificationId(id);
		if (name === "groups") setCurrentGroupId(id);
		if (name === "technician") setCurrentTechnicianId(id);
		if (name === "maintenance") setCurrentMaintenanceId(id);
		if (name === "task") setCurrentTaskId(id);
		if (name === "form") setCurrentFormId(id);
		if (name === "pois") setcurrentPOIId(id);
		if (name === "request") setcurrentRequestId(id);
		if (name === "permission") setcurrentPermissionId(id);
		if (name === "role") setcurrentRoleId(id);
		if (name === "customer") setcurrentCustomerId(id);
		if (name === "snag") setcurrentSnagId(id);
		if (name === "IR") setcurrentIRId(id);
		if (name === "company") setCurrentCompanyId(id);
		if (name === "team") setCurrentTeamId(id);
		if (name === "member") setCurrentMemberId(id);
		if (name === "configuration") setConfigurationId(id);
		if (name === "beatPlan") setCurrentBeatPlanId(id);

		setIsDeleting(true);
	};

	const handleShowObject = () => setObject(true);

	const handleShowObjectBody = () => setObjectbody(true);

	const handleShowSelected = () => setObjectselect(true);

	const handleShowGeo = () => setDisplayGeo(true);
	const handleCloseGeo = () => setDisplayGeo(false);

	const showDetails = (name, id) => {
		if (name === "vehicles") setCurrentVehicleId(id);
		if (name === "drivers") setCurrentDriverId(id);
		if (name === "users") setCurrentUserId(id);
		if (name === "subusers") setSubCurrentUserId(id);
		if (name === "geofences") setCurrentGeofenceId(id);
		if (name === "groups") setCurrentGroupId(id);
		if (name === "technician") setCurrentTechnicianId(id);
		if (name === "maintenance") setCurrentMaintenanceId(id);
		if (name === "form") setCurrentFormId(id);
		if (name === "task") setCurrentTaskId(id);
		if (name === "pois") setcurrentPOIId(id);
		if (name === "request") setcurrentRequestId(id);
		if (name === "permission") setcurrentPermissionId(id);
		if (name === "role") setcurrentRoleId(id);
		if (name === "customer") setcurrentCustomerId(id);
		if (name === "snag") setcurrentSnagId(id);
		if (name === "IR") setcurrentIRId(id);
		if (name === "beatPlan") setCurrentBeatPlanId(id);
		if (name === "submittal") {
			setcurrentSubmittalId(id);
		}
		if (name === "company") {
			setCurrentCompanyId(id);
		}
		if (name === "team") {
			setCurrentTeamId(id);
		}
		if (name === "member") {
			setCurrentMemberId(id);
		}
	};
	const triggerRefetch = () => setRefetchGeofences((prev) => !prev);
	const tryRefetch = useCallback(() => {
		setRefetchTrigger((prev) => prev + 1);
	}, []);

	
	return (
		<>
			<popupcontext.Provider
				value={{
					form,
					setForm,
					handleClose,
					handleShow,
					display,
					setDisplay,
					handleRemove,
					remove,
					object,
					handleShowObject,
					objectbody,
					handleShowObjectBody,
					setObjectbody,
					objectselect,
					setObjectselect,
					objectdraggable,
					setObjectDraggable,
					objectdraggablemini,
					setObjectDraggableMini,
					handleShowSelected,
					displayGeo,
					handleShowGeo,
					handleCloseGeo,
					currentVehicleId,
					setCurrentVehicleId,
					currentDriverId,
					setCurrentDriverId,
					currentUserId,
					setCurrentUserId,
					currentSubUserId,
					setSubCurrentUserId,
					currentTechnicianId,
					setCurrentTechnicianId,
					currentMaintenanceId,
					setCurrentMaintenanceId,
					currentGeofenceId,
					setCurrentGeofenceId,
					currentNotificationId,
					setCurrentNotificationId,
					currentGroupId,
					setCurrentGroupId,
					currentFormId,
					setCurrentFormId,
					currentTaskId,
					setCurrentTaskId,
					currentPOIId,
					setcurrentPOIId,
					currentRequestId,
					setcurrentRequestId,
					currentPermissionId,
					setcurrentPermissionId,
					currentCustomerId,
					setcurrentCustomerId,
					currentRoleId,
					setcurrentRoleId,
					currentCompanyId,
					setCurrentCompanyId,
					currentSnagId,
					setcurrentSnagId,
					currentIRId,
					setcurrentIRId,
					currentSubmittalId,
					setcurrentSubmittalId,
					currentTeamId,
					setCurrentTeamId,
					currentMemberId,
					setCurrentMemberId,
					showDetails,
					setIsDeleting,
					isDeleting,
					deleted,
					setDeleted,
					isEditing,
					setIsEditing,
					edited,
					setEdited,
					handleEditForm,
					attachments,
					setAttachments,
					attachmentsId,
					setAttachmentsId,
					picture,
					setPicture,
					historyPlayback,
					setHistoryPlayback,
					isPlaying,
					setIsPlaying,
					posIndex,
					setPosIndex,
					userPopup,
					setuserPopup,
					isFullScreen,
					setIsFullScreen,
					setRefetchGeofences,
					refetchGeofences,
					triggerRefetch,
					options,
					setOptions,
					tryRefetch,
					refetchTrigger,
					isControlsPopup,
					setIsControlsPopup,
					displayNotification,
					setDisplayNotification,
					displayAlert,
					setDisplayAlert,
					deleteItem,
					setDeleteItem,
					show,
					setShow,
					isLinking,
					setIsLinking,
					activeConnection,
					setActiveConnection,
					openShiftPopup,
					setOpenShiftPopup,
					reloadData,
					setReloadData,
					resubmission,
					setResubmission,
					isAssigning,
					setIsAssigning,
					activeRole,
					setActiveRole,
					isAssigningProjects,
					setIsAssigningProjects,
					activeCompany,
					setActiveCompany,
					isAssigningTeam,
					setIsAssigningTeam,
					activeUserForTeam,
					setActiveUserForTeam,
					isAssigningMemberToTeams,
					setIsAssigningMemberToTeams,
					activeMemberForTeams,
					setActiveMemberForTeams,
					isAssigningMembersToTeam,
					setIsAssigningMembersToTeam,
					activeTeamForMembers,
					setActiveTeamForMembers,
					isAssigningCompany,
					setIsAssigningCompany,
					activeUserForCompany,
					setActiveUserForCompany,
					konvaMode,
					setKonvamode,
					konvaCoord,
					setKonvaCoord,
					continueSetup,
					setContinueSetup,
					currentCompanyProjectId,
					setcurrentCompanyProjectId,
					currentConfigurationId,
					setConfigurationId,
					offlineMode,
					setOfflineMode,
					highlight,
					setHighlight,
					offlinePopup,
					setOfflinePopup,
					currentBeatPlanId,
					setCurrentBeatPlanId,
					currentPlannerId,
					setCurrentPlannerId,
				}}
			>
				{children}
			</popupcontext.Provider>
		</>
	);
}
